import React from "react";
// import { Button, Icon } from "antd-mobile";
import styles from "../css/App.css";
import { Carousel, Flex, Toast } from "antd-mobile";
import { request } from "../request";
import { checkToekn } from "../tools/wechatBrower";

const Img = (img = "", text = "", uri = "") => {
  let _img = img.img;
  let _text = img.text;
  return (
    <div className={styles["index-img"]}>
      <a href={img.uri} className={styles["a"]}>
        <img
          src={require("../static/" + _img + ".png")}
          alt=""
          // style={{ width: "85px", display: "block", marginBottom: "0.5rem" }}
          className={styles.image}
        />
        <div className={styles["index-text"]}>{_text}</div>
      </a>
    </div>
  );
};

const icp = () => {
  window.location.href = "https://beian.miit.gov.cn/"
}

export class Slide extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [
      ],
    };
  }

  async componentDidMount() {
    request(
      "index/getSlide",
      { token: localStorage.getItem("token") },
      ({ data }) => {
        if (data.code === 1) {
          let imgs = [];
          data.data.forEach((element) => {
            imgs.push("http://tsinghua-wechat-hq.oss-cn-beijing.aliyuncs.com" + element.slide_image);
          });
          this.setState({
            data: imgs,
          });
        } else {
          Toast.fail("获取轮播图失败");
        }
      }
    );
  }



  render() {
    return (
      <Carousel
        style={{ height: "220px" }}
        autoplay={true}
        infinite={true}
      // beforeChange={(from, to) => console.log(`slide from ${from} to ${to}`)}
      // afterChange={(index) => console.log("slide to", index)}
      >
        {this.state.data.map((val, index) => (
          <img
            key={index}
            src={val}
            alt=""
            style={{ maxHeight: "220px", verticalAlign: "top" }}
            onLoad={() => {
              // fire window resize event to change height
              window.dispatchEvent(new Event("resize"));
              // this.setState({ imgHeight: "auto" });
            }}
          />
        ))}
      </Carousel>
    );
  }
}

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: true,
      goods_list: [],
      data: [],
    };
  }

  getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      // eslint-disable-next-line
      if (pair[0] === variable) {
        return pair[1];
      }
    }
    return false;
  }

  async componentDidMount() {
    await checkToekn();
  }

  render() {
    if (this.state.show) {
      return (
        <div style={{ backgroundColor: "white" }}>
          <Slide data={this.state.data}></Slide>
          <div style={{ "minHeight": "calc(100vh - 220px - 30px)" }}>
            <Flex>
              <Flex.Item>
                <Img img="实验室介绍" text="实验室介绍" uri="#/Introduce" />
              </Flex.Item>
              <Flex.Item>
                <Img img="新闻资讯" text="新闻资讯" uri="#/news" />
              </Flex.Item>
              <Flex.Item>
                <Img img="资料下载" text="技术资料" uri="#/download" />
              </Flex.Item>
            </Flex>

            <Flex>
              <Flex.Item>
                <Img img="个人中心" text="个人中心" uri="#/my" />
              </Flex.Item>
              <Flex.Item>
                <Img img="我要预约" text="我要送检" uri="#/yuyue" />
              </Flex.Item>
              <Flex.Item>
                <Img img="联系我们" text="联系我们" uri="#/contact" />
              </Flex.Item>
            </Flex>

            {/* <Flex>
              <Flex.Item>
                <Img img="技术服务" text="成果支撑" uri="#/TechnicalService" />
              </Flex.Item>
              <Flex.Item>
                <Img img="送样须知" text="送检须知" uri="#/test_know" />
              </Flex.Item>
              <Flex.Item>
                <Img img="仪器设备" text="仪器设备" uri="#/equipment" />
              </Flex.Item>
            </Flex> */}


            <Flex>
              <Flex.Item>
                <Img img="液质联用" text="液质联用" uri="#/equipment/1" />
              </Flex.Item>
              <Flex.Item>
                <Img img="气质联用" text="气质联用" uri="#/equipment/2" />
              </Flex.Item>
              <Flex.Item>
                <Img img="元素分析" text="元素分析" uri="#/equipment/3" />
              </Flex.Item>
            </Flex>

            <Flex>
              <Flex.Item>
                <Img img="液相色谱" text="液相色谱" uri="#/equipment/4" />
              </Flex.Item>
              <Flex.Item>
                <Img img="气相色谱" text="气相色谱" uri="#/equipment/5" />
              </Flex.Item>
              <Flex.Item>
                <Img img="样品制备" text="样品制备" uri="#/equipment/6" />
              </Flex.Item>
            </Flex>

          </div>
          <div
            className={styles.bottom}
          >
            <span style={{ color: "#999999 ", fontSize: "12px" }} onClick={icp} >
              浙ICP备20000979号
            </span>
            <span style={{ color: "#999999 ", fontSize: "12px", margin: '0 1rem' }}>|</span>
            <span style={{ color: "#999999 ", fontSize: "12px" }}>
              开发请联系WX:YSKC0353
            </span>
          </div>
        </div>
      );
    } else {
      return <div></div>;
    }
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/pages/App.js